import { useContainerSize } from '@bimser/core';
import * as React from 'react';
import ContentLoader from 'react-content-loader';
import { findMessage } from '../BCIntl';
import getContent, { ContentType } from './Contents';
import { ISkeletonProps } from './entities';

const BCSkeleton: React.FC<ISkeletonProps> = props => {
	const targetRef = React.useRef<HTMLDivElement>();
	const dimensions = useContainerSize(targetRef);
	const { contentType, loadingStatus, rowCount, size, ...restProps } = props;

	if (!loadingStatus) return <>{props.children || null}</>;

	return (
		<div ref={targetRef}>
			<ContentLoader
				title={findMessage.get('100127')}
				{...restProps}
				height={props.height || dimensions.height || 800}
				width={props.width || dimensions.width || 480}
			>
				{getContent({
					...props,
					...{
						size: {
							width: dimensions.width,
							height: dimensions.height
						}
					}
				})}
			</ContentLoader>
		</div>
	);
};

export default BCSkeleton;
export { ContentType, ISkeletonProps };
